export default __webpack_public_path__ + "static/media/extra-480.51ca36a3.jpg";